import React, { useEffect, useState } from "react";
import ConfirmDialog from "../../../../components/actionDialogs/confirmDialog";
import Loader from "../../../../components/loader/loader";
import Snackbar from "../../../../components/snackbar/snackbar";
import CustomTable from "../../../../components/table/table";
import ReactHtmlParser from "react-html-parser";
import {
  admin_notification_delete,
  admin_notification_list,
} from "../../admin.api";
import ManageScrolling from "./manage/manage";
import "./view.css";
import jwtDecode from "jwt-decode";
export default function View(props) {
  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const [data, setdata] = useState([]);
  const [addNew, setAddNew] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [formData, setFormData] = useState({});
  const [edit, setEdit] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [openAction, setOpenAction] = useState(false);
  const [activeData, setActiveData] = useState({});
  const [view, setView] = useState(false);
  const handleEventList = () => {
    setIsActive(true);
    admin_notification_list().then((res) => {
      let tdata = res.data;
      tdata.forEach((item, index) => {
        item["slno"] = index + 1;
      });
      setdata(tdata);
      setIsActive(false);
    });
  };
  useEffect(() => {
    handleEventList();
  }, []);
  const handleClose = () => {
    setAddNew(false);
    setEdit(false);
    setFormData({});
    handleEventList();
  };
  const handleEdit = (data) => {
    setFormData(data);
    setView(false);
    setEdit(true);
    setAddNew(true);
  };
  const handleAddNew = () => {
    setAddNew(true);
    setView(false);
  };
  const handleDelete = (data) => {
    setActiveData(data);
    setOpenAction(true);
  };
  const handleCancelDelete = () => {
    setOpenAction(false);
  };
  const handleDeleteConfirm = (data) => {
    setOpenAction(false);
    setIsActive(true);
    admin_notification_delete(data.uuid)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setIsActive(false);
        setSnackOpen(true);
      })
      .catch((error) => {
        setSnackMessage(error.message);
        setIsSnackError(true);
        setIsActive(false);
        setSnackOpen(true);
      });
  };
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      handleEventList();
    }
  };
  const handleView = (data) => {
    setFormData(data);
    setAddNew(true);
    setView(true);
  };
  return (
    <div>
      <Loader open={isActive} />
      <div className="view-container">
        <h6>
          <b>Scrolling Notification</b>
        </h6>
        <hr />
        {adminType === 1 && (
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={(e) => handleAddNew(e)}
          >
            Add New
          </button>
        )}
        <CustomTable
          {...props}
          columns={[
            { title: "Sl. No", type: "dynId" },
            { title: "Title", field: "notification_title_en" },
            { title: "Description", field: "notification_desc_en" , render: (rowData) => ReactHtmlParser(rowData.notification_desc_en) },
            { title: "Link", field: "link" },
          ]}
          data={data}
          actions={
            adminType === 2
              ? [
                { type: "view", handleClick: handleView },
                { type: "edit", handleClick: handleEdit },
                { type: "delete", handleClick: handleDelete },
              ]
              : [
                { type: "view", handleClick: handleView },
                { type: "edit", handleClick: handleEdit },
              ]
          }
        />
      </div>
      {addNew && (
        <ManageScrolling
          open={addNew}
          edit={edit}
          view={view}
          handleClose={handleClose}
          formData={formData}
        />
      )}
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      {openAction && (
        <ConfirmDialog
          open={openAction}
          title="Delete Scrolling Notification ?"
          data={activeData}
          message="Are you sure to delete this notification?"
          secondary_action="Cancel"
          primary_action="Delete"
          handleClose={handleCancelDelete}
          handleConfirm={handleDeleteConfirm}
        />
      )}
    </div>
  );
}
